import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import { useNavigate } from 'react-router-dom';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import { Grid, Box, MenuItem, Card, CardContent } from '@mui/material';

import ApiService from '../../../../services/ApiService';
import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import ModalConfirmation from '../../../../components/Modals/ModalConfirmation';
import ButtonSalesCostView from './Buttons/ButtonSalesCostView';
import HeaderInfo from '../../../../components/Components/HeaderInfo';
import CustomToastContainer, { CustomDatePicker, Selection, showToast } from '../../../../components/ui';
import { setDateFormat } from '../../../../utils/date';
import { PrintExcel, PrintPDF } from '../../../../utils/reusableFunction';

const SalesCostView = forwardRef((props, ref) => {
    const [isLoadingBackDrop, setIsLoadingBackDrop] = useState(true);
    const history = useNavigate();
    const paramRegUserAccess = 'regUserAccess/regUserAccess';
    const [DataRegUserAccess, setDataRegUserAccess] = useState([]);

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const paramJobOwner = 'jobOwner/jobOwner';
    const [jobOwnerData, setJobOwnerData] = useState([]);
    const [jobOwnerId, setJobOwnerId] = useState(0);
    const paramJobType = 'jobType/jobType';
    const [jobTypeData, setJobTypeData] = useState([]);
    const [jobTypeId, setJobTypeId] = useState(0);

    const [isModalConfirmation, setIsModalConfirmation] = useState(false);
    const [titleModalConfirmation, setTitleModalConfirmation] = useState('');
    const [titleConfirmation, setTitleConfirmation] = useState('');

    const BreadcrumbsItems = [
        { label: 'Majura', link: '/Majura', style: '' },
        { label: 'Sales Cost', link: '/Majura/SalesCostReport', style: { color: '#0087C2', fontWeight: '700' } },
    ];

    useImperativeHandle(ref, () => ({
        localSave() {

        }
    }));

    useEffect(() => {
        document.title = 'Sales Cost - ' + JSON.parse(localStorage.getItem('branchName'));
        getDataAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDataAccess = () => {
        setIsLoadingBackDrop(true);
        let params = [];
        let pId = 0;
        let listMenu = JSON.parse(localStorage.getItem("dataMenuCode")) || [];
        let hasAccess = false

        const indexMenu = listMenu.findIndex((elm) => elm.code === 'OSHOR')
        if (indexMenu !== -1) {
            pId = listMenu[indexMenu].id
            hasAccess = true
        }

        if (hasAccess) {
            params = [
                ...params,
                { 'attr': 'permissionId', 'value': '' + pId },
                { 'attr': 'userId', 'value': '' + JSON.parse(localStorage.getItem("userId")) },
                { 'attr': 'roleId', 'value': '' + JSON.parse(localStorage.getItem("roleId")) }
            ]
            ApiService.IdentityPostByPage(paramRegUserAccess, 'PAGE', 1, 100, params, [])
                .then((response) => {
                    if (response.data.code === 200) {
                        setDataRegUserAccess(response.data.data.userAccess);

                        getDataJobType(1, 100);
                    }
                })
                .catch(function (error) {
                    console.error('error saat fetch', error)
                    history('/Majura');
                })
        }
        else {
            history('/Majura');
        }
    }

    const getDataJobOwner = (pageNumber, pageSize, filters, orderBy) => {
        ApiService.DynamicPostByPage(paramJobOwner, 'SEARCH', pageNumber, pageSize, [], filters, orderBy)
            .then((response) => {
                if (response.data.code === 200) {
                    let array = [];

                    response.data.data.jobOwner.forEach(element => {
                        array = [...array, element];
                    });

                    if (array.length === 1) {
                        setJobOwnerData(array[0])
                        setJobOwnerId(array[0].id)
                    } else {
                        array.unshift({ id: 0, name: 'All Principle' })
                    }

                    setJobOwnerData(array);

                    getDateNow();
                }
            })
            .catch(function (error) {
                console.error('error saat fetch', error)
            })
    }

    const getDataJobType = (pageNumber, pageSize, filters, orderBy) => {
        ApiService.DynamicPostByPage(paramJobType, 'SEARCH', pageNumber, pageSize, [], filters, orderBy)
            .then((response) => {
                if (response.data.code === 200) {
                    let array = [{ id: 0, name: 'All Jobs' }];

                    response.data.data.jobType.forEach(element => {
                        array = [...array, element];
                    });

                    setJobTypeData(array);

                    getDataJobOwner(1, 100);
                }
            })
            .catch(function (error) {
                console.error('error saat fetch', error)
            })
    }

    const handleClickConfirmation = () => {
        if (isModalConfirmation === false) {
            setIsModalConfirmation(true);
        }
        else {
            setIsModalConfirmation(false);
        }
    }

    function ConfirmationCOSC() {
        if (titleConfirmation === 'Print') {
            PrintPDFData();
        }
        else if (titleConfirmation === 'Print Excel') {
            PrintExcelData();
        }
        setIsModalConfirmation(false);
    }

    const PrintData = () => {
        setTitleConfirmation('Print')
        setTitleModalConfirmation('Sales Cost');
        handleClickConfirmation();
    };

    const PrintDataExcel = () => {
        setTitleConfirmation('Print Excel')
        setTitleModalConfirmation('Sales Cost');
        handleClickConfirmation();
    }

    function PrintPDFData() {
        setIsLoadingBackDrop(true);

        let params = [
            {
                "attr": "StartDate",
                "value": '' + dateFrom
            },
            {
                "attr": "EndDate",
                "value": '' + dateTo
            },
            {
                "attr": "JobTypeId",
                "value": '' + jobTypeId
            },
            {
                "attr": "JobOwnerId",
                "value": '' + jobOwnerId
            }
        ]

        let reportLink = 'Reports/Finance/Print/ControlReport/SalesCostReport/SalesCostReport/PrintSalesCost?typeReport=pdf';
        PrintPDF(setIsLoadingBackDrop, 'Sales Cost', reportLink, params);
    }

    function PrintExcelData() {
        setIsLoadingBackDrop(true);

        let params = [
            {
                "attr": "StartDate",
                "value": '' + dateFrom
            },
            {
                "attr": "EndDate",
                "value": '' + dateTo
            },
            {
                "attr": "JobTypeId",
                "value": '' + jobTypeId
            },
            {
                "attr": "JobOwnerId",
                "value": '' + jobOwnerId
            }
        ]

        let reportLink = 'Reports/Finance/Print/ControlReport/SalesCostReport/SalesCostReport/PrintSalesCost?typeReport=xls';
        PrintExcel(setIsLoadingBackDrop, 'Sales Cost', reportLink, params);
    }

    function getDateNow() {
        setIsLoadingBackDrop(false);
        setDateFormat(new Date(), setDateFrom);
        setDateFormat(new Date(), setDateTo);
    }

    function handleDate(source, value) {
        if (source === 'From') {
            if (value > dateTo) {
                showToast({ type: 'error', message: 'Period From Can\'t Be Greater Than Period To' });
            }
            else {
                setDateFrom(value);
            }
        }
        else {
            if (value < dateFrom) {
                showToast({ type: 'error', message: 'Period To Can\'t Be Smaller Than Period From' });
            }
            else {
                setDateTo(value);
            }
        }
    }

    const ButtonComponents = () => {
        return (
            <ButtonSalesCostView
                PrintData={PrintData}
                PrintExcel={PrintDataExcel}
                DataRegUserAccess={DataRegUserAccess}
            />
        )
    }

    return (
        <Box className='w-100' sx={{ width: '100%', p: 3 }}>
            <CustomToastContainer />
            <Grid container spacing={0} direction="column">
                <HeaderInfo
                    title={'Sales Cost'}
                    isJobType={false}
                    BreadcrumbsItems={BreadcrumbsItems}
                    ButtonComponents={ButtonComponents}
                />

                <Grid item xs={12} style={{ 'width': '100%', 'borderRadius': '5px' }}>
                    <div style={{ marginTop: '24px' }}>
                        <Grid
                            container
                            spacing={'32px'}
                        >
                            <Grid
                                item
                                xl={7}
                                lg={7}
                                sm={7}
                                xs={12}
                            >
                                <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={'16px'}
                                        >
                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <CustomDatePicker
                                                    type='date'
                                                    value={dateFrom}
                                                    label="Period From"
                                                    onChange={(e) => handleDate('From', e)}
                                                    formControlProps={{ sx: { width: '100%' } }}
                                                />

                                                <Selection
                                                    id='0'
                                                    fullWidth={true}
                                                    value={jobOwnerId}
                                                    label={'Principle'}
                                                    placeholder={'Select Principle'}
                                                    onChange={(e) => setJobOwnerId(e.target.value)}
                                                    formControlProps={{ sx: { marginTop: '16px !important' } }}
                                                >
                                                    {
                                                        jobOwnerData.map((data) => (
                                                            <MenuItem sx={{ fontSize: '12px' }} id={data.id} key={data.id} value={data.id}>
                                                                {data.name}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Selection>
                                            </Grid>

                                            <Grid
                                                item
                                                xl={6}
                                                lg={6}
                                                sm={6}
                                                xs={12}
                                            >
                                                <CustomDatePicker
                                                    type='date'
                                                    value={dateTo}
                                                    label="Period To"
                                                    onChange={(e) => handleDate('To', e)}
                                                    formControlProps={{ sx: { width: '100%' } }}
                                                />

                                                <Selection
                                                    id='0'
                                                    fullWidth={true}
                                                    value={jobTypeId}
                                                    label={'Job'}
                                                    placeholder={'Select Job'}
                                                    onChange={(e) => setJobTypeId(e.target.value)}
                                                    formControlProps={{ sx: { marginTop: '16px' } }}
                                                >
                                                    {
                                                        jobTypeData.map((data) => (
                                                            <MenuItem sx={{ fontSize: '12px' }} id={data.id} key={data.id} value={data.id}>
                                                                {data.name}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Selection>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {
                isLoadingBackDrop && (
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={isLoadingBackDrop}
                    >
                        <LoadingSpinner />
                    </Backdrop>
                )
            }

            {
                isModalConfirmation && (
                    <ModalConfirmation
                        isModal={isModalConfirmation}
                        titleModal={titleModalConfirmation}
                        title={titleConfirmation}
                        handleClick={handleClickConfirmation}
                        ConfirmationData={ConfirmationCOSC}
                    />
                )
            }
        </Box>
    )
})

export default SalesCostView